import { ISorter, ISorterConfig, ISorterExpression, SorterConfig } from "pbc.types";

export interface IProjektArtSorter extends ISorter {
  id?: ISorterExpression;
  name?: ISorterExpression;
  initialen?: ISorterExpression;
  beschreibung?: ISorterExpression;
}

export const ProjektArtSorterConfig: ISorterConfig = [
  SorterConfig('id', 'Id'),
  SorterConfig('name', 'Name'),
  SorterConfig('initialen', 'Initialen'),
  SorterConfig('beschreibung', 'Beschreibung')
];
